<template>
    <div class="business-content-main" >
        <div class="bread-nav">
            <breadcrumb></breadcrumb>
        </div>
        <div class="tab-item-ctn">
            <div class="search-ctn">
                <div class="search-ctn-left">  
                    <div class="search-name">部门</div>
                    <el-cascader
                        ref="orgCascader"
                        class="search-item"
                        v-model="searchData.OrgId"
                        :options="orgSearchData"
                        :props="cascaderProps"
                        size="small"
                        clearable
                        @change="getSIdData"
                        @visible-change="getOrgTree"
                        style="width: 120px;" 
                    ></el-cascader>
                    <div class="search-name">打标人</div>
                    <el-select v-model="searchData.SIds" multiple collapse-tags size="small" class="search-item" filterable placeholder="请选择">
                        <el-option v-for="item in SIdList" :key="item.EmployeeId" :label="item.EmployeeName" :value="item.EmployeeId"></el-option>
                    </el-select>
                    <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="handleSearch">查询</el-button>
                    <el-button size="small" icon="el-icon-refresh" class="search-btn btn-primary" @click="resetSearch">重置</el-button>
                <el-button size="small" class="search-btn btn-primary" @click="showSearchDialog">更多条件（F2）</el-button>
                </div>
            </div>
            <div class="table-ctn">
                <el-table
                    :header-cell-style="{ background: '#F2F6FC' }"
                    :data="tableData"
                    border
                    style="width: 100%"
                    :default-sort="{ prop: 'LabelCount', order: 'descending' }"
                    @sort-change="sortChange"
                >
                    <el-table-column show-overflow-tooltip width="60px" type="index" :index="indexMethod" label="排名"></el-table-column>
                    <el-table-column show-overflow-tooltip min-width="130px" prop="APCode" label="汽配编码"></el-table-column>
                    <el-table-column show-overflow-tooltip min-width="130px" prop="GoodName" label="汽配名称"></el-table-column>
                    <el-table-column show-overflow-tooltip min-width="150px" prop="AutoSerise" label="适用车型"></el-table-column>
                    <el-table-column show-overflow-tooltip min-width="120" prop="Brand" label="品牌"></el-table-column>
                    <el-table-column show-overflow-tooltip min-width="120" prop="APCate" label="分类"></el-table-column>
                    <el-table-column show-overflow-tooltip min-width="150" sortable="custom" prop="LabelCount" label="打印标签总数"></el-table-column>
                    <el-table-column show-overflow-tooltip min-width="120" sortable="custom" prop="GoodsCount" label="商品总数"></el-table-column>
                    <el-table-column show-overflow-tooltip min-width="120" prop="TotalCost" label="总成本"></el-table-column>
                    <el-table-column show-overflow-tooltip min-width="120" sortable="custom" prop="StoreCount" label="存放总数"></el-table-column>
                </el-table>
            </div>
            <div class="pagination-ctn">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="searchData.page"
                    :page-sizes="[commonPageSize, 20, 30, 40, 50]"
                    :page-size="searchData.limit"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="tableDataLength"
                ></el-pagination>
            </div>         
        </div>
        
        <el-dialog
            :close-on-click-modal="false"
            title="标签统计搜索"
            :visible.sync="dialogVisible"
            width="400px"
            append-to-body
            v-dialog-drag
            lock-scroll
            :modal="false"
            id="search-page-dialog"
            custom-class="search-item-dialog"
            style="margin-left: -170px"
        >
            <div class="dialog-content" v-if="dialogVisible">
                <el-form ref="form" label-position="left" label-width="90px">
                    <el-form-item label="汽配编码">
                        <el-input class="search-item" size="small" v-model="searchData.APCode" placeholder="汽配编码"></el-input>
                    </el-form-item>
                    <el-form-item label="汽配名称">
                        <el-select
                            size="small"
                            style="width: 100%"
                            v-model="searchData.GoodName"
                            remote
                            filterable
                            allow-create
                            clearable
                            placeholder="请输入配件名称"
                            :remote-method="searchGoodName"
                            v-select-scroll-more="searchGoodNameLoad"
                            popper-class="my-select"
                        >
                            <el-option v-for="item in goodNameOptions" :key="item" :label="item" :value="item"> </el-option>
                            <el-option v-if="optionLoading" disabled value="" style="text-align: center">
                                加载中
                                <i class="el-icon-loading"></i>
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="适用车型">
                        <el-select
                            size="small"
                            style="width: 100%"
                            v-model="searchData.AutoSerise"
                            remote
                            filterable
                            allow-create
                            clearable
                            placeholder="请输入车型"
                            :remote-method="searchAutoSerise"
                            v-select-scroll-more="searchAutoSeriseLoad"
                            popper-class="my-select"
                        >
                            <el-option v-for="item in autoSeriseOptions" :key="item" :label="item" :value="item" style="width: 300px"> </el-option>
                            <el-option v-if="optionLoading" disabled value="" style="text-align: center">
                                加载中
                                <i class="el-icon-loading"></i>
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="汽配品牌">
                        <el-select
                            v-model="searchData.BrandName"
                            multiple
                            collapse-tags
                            filterable
                            clearable
                            size="small"
                            style="width: 100%"
                            @visible-change="brandVisibleChange($event)"
                        >
                            <el-option :key="item.Text" v-for="item in brand" :label="item.Text" :value="item.Text"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="汽配分类">
                        <el-select
                            size="small"
                            style="width: 100%"
                            v-model="searchData.APCate"
                            multiple
                            collapse-tags
                            filterable
                            clearable
                            @visible-change="cateVisibleChange($event)"
                        >
                            <el-option v-for="optionItem in typeList1" :key="optionItem.Value" :label="optionItem.Text" :value="optionItem.Value">
                                <div class="option-content">
                                    <div>{{ optionItem.Text }}</div>
                                </div>
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="打标时间">
                        <el-date-picker
                        v-model="dateTimes"
                        size="small"
                        class="search-item"
                        type="daterange"
                        align="right"
                        style="width: 100%"
                        unlink-panels
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        :picker-options="pickerOptions"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        @change="onDateTimeSelect"
                        ></el-date-picker>
                    </el-form-item>
                </el-form>
                <div class="dialog-footer">
                    <el-button class="btn-primary" size="small" @click="handleSearch">查询（Enter）</el-button>
                    <el-button size="small" @click="resetSearch">重置</el-button>
                    <el-button size="small" @click="closeSearchDialog">关闭（Esc）</el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import breadcrumb from '@/components/common/breadcrumb';
import mixin from '@/mixins/mixin';
import pageLimitMixin from '@/mixins/pageLimitMixin';
export default {
    mixins: [mixin, pageLimitMixin],
    name: 'goodSearch',
    components: {
        breadcrumb
    },
    data() {
        return {
            dateTimes: [],
            brand: [],
            orgSearchData: [],
            cascaderProps: {
                emitPath: false,
                expandTrigger: 'hover',
                children: 'Childrens',
                label: 'Name',
                value: 'Id',
                checkStrictly: true
            },
            SIdList: [],
            typeList1: [],
            searchData: {
                AutoSerise: '',
                APCode: '',
                BrandName: [],
                GoodName: '',
                APCate: [],
                OrgId: '',
                SIds: [],
                SortProp: '',
                SortType: '',
                StartDate: '',
                EndDate: '',
                page: 1,
                limit: 15
            },
            goodsCategories: [],
            tableData: [],
            tableDataLength: 0,
            pickerOptions: {
                shortcuts: [
                    {
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近半年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
                            picker.$emit('pick', [start, end]);
                        }
                    }
                ]
            },
            optionLoading: false,
            goodNameOptions: [],
            goodNameForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            autoSeriseOptions: [],
            autoSeriseForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },  
            dialogVisible: false
        };
    },
    beforeRouteLeave(to, from, next) {
        document.removeEventListener('keydown', this.handleKeyEvent);
        if (this.dialogVisible) this.dialogVisible = false;
        next();
    },
    created() {
        document.addEventListener('keydown', this.handleKeyEvent);

        //当前设定的日期时间
        let d = new Date();
        let year1, month1, day1;
        [year1, month1, day1] = [d.getFullYear(), d.getMonth(), d.getDate()];
        let date1 = new Date(year1, month1, day1 - 1, 0);
        this.dateTimes.push(date1);
        //前一天设定的日期时间
        let year2, month2, day2;
        d.setTime(d.getTime());
        [year2, month2, day2] = [d.getFullYear(), d.getMonth(), d.getDate()];
        let date2 = new Date(year2, month2, day2 - 1, 0);
        this.dateTimes.unshift(date2);

        this.searchData.StartDate = date2;
        this.searchData.EndDate = date1;
    },
    mounted() {
        this.getTableData();
    },
    methods: {
        handleKeyEvent(e) {
            let key = window.event.keyCode;
            let that = this;
            if (key === 113) {
                that.dialogVisible = true;
            }
            if (key === 27) {
                if (that.dialogVisible) that.dialogVisible = false;
            }
            if (key === 13) {
                that.handleSearch();
                return;
            }
            //左键
            if (key == 37) {
                if (this.searchData.page > 1) {
                    this.searchData.page -= 1;
                    this.getTableData();
                }
                return;
            }
            //右键
            if (key == 39) {
                if (this.searchData.page < Math.ceil(this.tableDataLength / this.searchData.limit)) {
                    this.searchData.page += 1;
                    this.getTableData();
                }
                return;
            }
        },
        searchGoodsBrand() {
            this.$util
                .searchGoodsBrand()
                .then(data => {
                    this.brand = data;
                })
                .catch(() => {});
        },
        searchGoodsType() {
            this.$util
                .getEntpApCategoryList()
                .then(data => {
                    if (!data) return;
                    this.typeList1 = data;
                })
                .catch(() => {});
        },
        // 重置表单
        resetSearch() {
            this.searchData = {
                AutoSerise: '',
                APCode: '',
                BrandName: [],
                GoodName: '',
                APCate: [],
                OrgId: '',
                SIds: [],
                SortProp: '',
                SortType: '',
                StartDate: '',
                EndDate: '',
                page: 1,
                limit: this.commonPageSize
            };
            this.dateTimes = [];
        },
        // 获取数据
        getTableData() {
            this.$util
                .axiosPost({
                    url: '/api/DataStatistics/LabelStatistics',
                    data: this.searchData
                })
                .then(res => {
                    let data = res.data;
                    if (!data) {
                        this.noData = true;
                        return;
                    }
                    this.noData = false;
                    this.tableData = data;
                    this.tableDataLength = res.count;
                })
                .catch(() => {});
        },
        handleSearch() {
            this.searchData.page = 1;
            this.getTableData();
        },
        handleSizeChange(val) {
            this.searchData.page = 1;
            this.searchData.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.searchData.page = val;
            this.getTableData();
        },
        brandVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.brand.length == 0) that.searchGoodsBrand();
            }
        },
        cateVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.typeList1.length == 0) that.searchGoodsType();
            }
        },
        sortChange(event) {
            this.searchData.SortProp = event.prop;
            this.searchData.SortType = event.order;
            this.searchData.page = 1;
            this.getTableData();
        },
        indexMethod(index) {
            return index + 1 + (this.searchData.page - 1) * this.searchData.limit;
        },
        onDateTimeSelect(val) {
            if (val != null) {
                this.searchData.StartDate = val[0];
                this.searchData.EndDate = val[1];
            } else {
                this.searchData.StartDate = '';
                this.searchData.EndDate = '';
            }
        },   
        //获取组织树
        getSIdData() {
            if (this.searchData.OrgId) {
                this.$util.getSIdListByOrg(this.searchData.OrgId).then(data => {
                    this.SIdList = data;
                });
            }
        },
        getOrgTree(isShow) {
            if (isShow && this.orgSearchData.length == 0) {
                this.$util
                    .axiosGet({
                        url: '/api/EntpInfoManagement/GetOrgTree'
                    })
                    .then(res => {
                        if (res.data) {
                            this.orgSearchData = this.getTreeData(res.data);
                        }
                    });
            }
        },
        // 数列
        getTreeData(data) {
            for (let i = 0; i < data.length; i++) {
                if (data[i].Childrens.length < 1) {
                    data[i].Childrens = undefined;
                } else {
                    this.getTreeData(data[i].Childrens);
                }
            }
            return data;
        },
        async searchGoodName(key) {
            if (![undefined].includes(key)) {
                this.goodNameForm.Page = 1;
                this.goodNameForm.stopLoad = false;
                this.goodNameForm.key = key;
                this.goodNameOptions = [];
            }
            if (this.goodNameForm.stopLoad) return;
            this.optionLoading = true;
            const data = await this.$util.searchPartAttr(this.goodNameForm.key, 1, this.goodNameForm.Page, this.goodNameForm.Limit);
            this.optionLoading = false;
            if (data) {
                if (!data) return;
                this.goodNameForm.stopLoad = data.length < this.goodNameForm.Limit;
                this.goodNameOptions = [...this.goodNameOptions, ...data];
            }
        },
        searchGoodNameLoad() {
            this.goodNameForm.Page += 1;
            this.searchGoodName();
        },
        async searchAutoSerise(key) {
            if (![undefined].includes(key)) {
                this.autoSeriseForm.Page = 1;
                this.autoSeriseForm.stopLoad = false;
                this.autoSeriseForm.key = key;
                this.autoSeriseOptions = [];
            }
            if (this.autoSeriseForm.stopLoad) return;
            this.optionLoading = true;
            const data = await this.$util.searchPartAttr(this.autoSeriseForm.key, 2, this.autoSeriseForm.Page, this.autoSeriseForm.Limit);
            this.optionLoading = false;
            if (data) {
                if (!data) return;
                this.autoSeriseForm.stopLoad = data.length < this.autoSeriseForm.Limit;
                this.autoSeriseOptions = [...this.autoSeriseOptions, ...data];
            }
        },
        searchAutoSeriseLoad() {
            this.autoSeriseForm.Page += 1;
            this.searchAutoSerise();
        },
        closeSearchDialog() {
            this.dialogVisible = false;
        },
        showSearchDialog() {
            this.dialogVisible = true;
        },
    }
};
</script>
<style lang="less" scoped>
.data-count {
    padding: 5px;
    display: flex;
    .data-item {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 16.6%;
        border-right: 1px solid @border4Color;
        > p:nth-child(1) {
            margin-bottom: 5px;
        }
    }
}
.ops-ctn {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .image-sup {
        width: 25px;
        height: 25px;
        margin-right: 4px;
    }
    .image-cus {
        width: 25px;
        height: 25px;
    }
}
.saveProgress {
    position: absolute;
    top: 45%;
    left: 45%;
    z-index: 9999;
}
.exportmsg {
    display: flex;
    flex-direction: column;
    align-items: center;
    z-index: 10000;
    position: absolute;
    top: 48vh;
    left: 55vh;
    font-size: 22px;
    color: rgb(243, 62, 62);
}
</style>